module.exports = __webpack_public_path__ + "static/bachelor-nation-2941414afedd7b05fb84dbae92326eb8.jpg";